import React from "react";
import Typography from "@dtci/spellbook/Typography";
import Button from "@dtci/spellbook/Button";
export { ValidationError } from "tap/components/ValidationError";
export { SectionHeader } from "tap/components/SectionHeader";
export { FormCard } from "tap/components/FormCard";

/**
 * Tier format card with optional remove button
 */
export const TierFormatCard = ({ children, onRemove }) => (
  <div className="tier-format-card">
    {onRemove && (
      <Button
        iconType="fa-solid fa-trash"
        styleType="link"
        className="tier-format-card-remove-btn"
        onClick={onRemove}
        aria-label="Remove tier format"
      />
    )}
    {children}
  </div>
);

/**
 * Window card component
 */
export const WindowCard = ({ children }) => (
  <div className="window-card">{children}</div>
);

/**
 * Empty state component for when no windows are selected
 */
export const EmptyState = ({ icon, message }) => (
  <div className="empty-state">
    <i className={`${icon} empty-state-icon`} />
    <Typography variant="T20" className="empty-state-message">
      {message}
    </Typography>
  </div>
);

/**
 * Card label component for tier format and window cards
 */
export const CardLabel = ({ icon, children }) => (
  <div className="card-label">
    <i className={`${icon} card-label-icon`} />
    {children}
  </div>
);

/**
 * Tier row cell component
 */
export const TierRowCell = ({ children, showLabel, label }) => (
  <div className="tier-row-cell">
    {showLabel && (
      <Typography variant="T20" bold className="tier-row-cell-label">
        {label}
      </Typography>
    )}
    {children}
  </div>
);
